import { type Theme } from "@mui/material"
import { MultiWidgetTheme } from "../../../definitions/components.types"

export const createMultiWidgetTheme = (_: Theme): MultiWidgetTheme => ({
    styleOverrides: {
        root: {
            ".widget__card": {
                height: "14em",
            },
        },
    },
})
